/**
 * Табличные выгрузки из пакета — для сравнения с внешними источниками котировок
 * (терминал, Yahoo Finance, Polygon, Nasdaq и т.п.) в любой электронной таблице.
 * Разделитель «;», десятичная точка; время — UTC (ISO 8601).
 */
import type { VerificationPackage } from './types.ts';

const row = (cells: (string | number | boolean | null | undefined)[]) =>
  cells.map((c) => (c === null || c === undefined ? '' : /[;"\n]/.test(String(c)) ? `"${String(c).replace(/"/g, '""')}"` : String(c))).join(';');

/** Исходные минутные бары акций состава. */
export function componentsCsv(pkg: VerificationPackage): string {
  const lines = [row(['symbol', 'name', 'time_utc', 'open', 'high', 'low', 'close', 'volume', 'base_price'])];
  for (const c of pkg.index.components) for (const b of c.bars) lines.push(row([c.symbol, c.name, b.time, b.o, b.h, b.l, b.c, b.v, c.basePrice]));
  return lines.join('\n') + '\n';
}

/** Бары агрегата, показанные игрокам (в пунктах). */
export function aggregateCsv(pkg: VerificationPackage): string {
  const lines = [row(['k', 'market_time_utc', 'open', 'high', 'low', 'close', 'activity'])];
  for (const b of pkg.index.servedBars) lines.push(row([b.k, b.marketTime, b.o, b.h, b.l, b.c, b.v]));
  return lines.join('\n') + '\n';
}

/** Журнал ходов. */
export function actionsCsv(pkg: VerificationPackage): string {
  const lines = [row(['seq', 'time_utc', 'round', 'kind', 'player', 'action', 'amount_cr', 'auto', 'text'])];
  for (const a of pkg.actions)
    lines.push(row([a.seq, new Date(a.at).toISOString(), a.round, a.kind, a.name, a.action, a.amount === undefined ? '' : (a.amount / 100).toFixed(2), a.auto, a.text]));
  return lines.join('\n') + '\n';
}
